<template>
  <div :class="class_" :style="advanced?'':'display:block'">
    <div class="works-filter__block-item">
      <div class="works-filter__block-title">{{ $t("message.DeliveryPlRegion") }}</div>
    </div>

    <div class="all-work__filter">
      <div class="all-artists-filter__item">
        <div class="all-artists__dropdown">
          <dropdown_qsearch
            v-model="selected"
            :placeholder="placeholder"
            :on-change="change_val"
            main_class="input input_dropdown input_size-40 input_animate-label"
            input_class="ref-input ref-input-md ref-input-block"
            url_html="/action/qsearch?type=region&v=7&search="
            url_html_init="/action/qsearch?action=restore_search&section=region&v=7"/>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import dropdown_qsearch from "../../../../../components/lib/dropdown_qsearch";
  import FilterPlRegionMix from "../../../../../components/list/filter/FilterPlRegionMix";

  export default {
    components : { dropdown_qsearch },
    name      : 'filter-pl-region-sub',
    props:{
      is_show: { type: Boolean, default: true },
    },
    mixins: [FilterPlRegionMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_dark/components/list/filter/FilterPlRegionSub.vue